<div>
  <img [src]="baseUri + '/assets/sgzp-app2/images/header.svg'" alt="">
  <p>発注提案サービス</p>
</div>
